<template>
  <div class="picture-tab">
    <div v-show="activeName !== 'picture'" class="picture-container">
      <div
        v-if="selectedPictureResource.length > 0"
        v-loading="isPictureLoading"
        :class="{
          'picture-list': true,
          'local-picture-list': isShowLocal
        }"
        style="overflow-y: scroll"
      >
        <div
          v-for="(item, index) in selectedPictureResource"
          :key="item.resourceId"
          class="picture-style"
          @mouseenter="handlePictureOver(index, item)"
          @mouseleave="handlePictureOut"
          @mousedown="judgePictureDraggable(item)"
        >
          <i
            v-show="mouseTarget === index"
            class="el-icon-circle-plus-outline picture-plus-icon"
            title="添加"
            @click="handlePictureIconAdd(item)"
          ></i>
          <i
            v-show="mouseTarget === index"
            class="el-icon-delete picture-delete-icon"
            title="删除"
            @click="handleLocalPictureDelete(index)"
          ></i>
          <el-image
            fit="contain"
            lazy
            :src="item.resourceUrl"
            :draggable="materialList.length !== 0 && !!item.duration"
            @dragstart="handlePictureStart({
              e: $event,
              item: item,
              index: index,
              list: 'pictureTrackList',
              prefix: 'picture',
              trackId: 'pictureTrack',
              isTrackDrag: false
            })"
            @drag="handlePictureDragging"
            @dragend="handlePictureDragEnd"
          >
            <div slot="error" class="image__error">加载失败</div>
          </el-image>
           <div class="picture-style-title">{{item.resourceName}}</div>
        </div>
      </div>
      <div v-else class="picture-empty">
        <span>暂无贴图</span>
      </div>
      <div class="button-style">
        <el-button @click="handleOpenDialog">历史上传</el-button>
        <el-upload
          class="location-upload"
          action="#"
          accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.GIF"
          :disabled="isUploading"
          :multiple="true"
          :show-file-list="false"
          :http-request="uploadFile"
        >
          <div class="methods-button" >
            <el-button type="primary" :disabled="isUploading" :loading="isUploading">本地上传</el-button>
          </div>
        </el-upload>
        <span class="message"></span>
      </div>
    </div>
    <el-card v-show="isShowCard" v-loading="isCardLoading" class="picture-card">
      <el-image
        fit="contain"
        :src="cardSrc"
        @load="loadedCardContent"
      ></el-image>
      <!-- <video
        v-if="cardType === 'video'"
        muted
        autoplay
        loop
        :src="cardSrc"
        @loadedmetadata="loadedCardContent"
      ></video> -->
    </el-card>
    <div
      v-show="activeName === 'picture'"
      class="operation-tab"
    >
      <!-- <div>
        <span>旋转</span>
        <el-slider
          v-model="tabRotate"
          class="operation-area"
          :show-input="true"
          :show-tooltip="false"
          :min="0"
          :max="360"
        ></el-slider>
      </div> -->
      <div>
        <span>缩放</span>
        <el-slider
          v-model="tabResize"
          class="operation-area"
          id="resize-button"
          :show-input="true"
          :show-tooltip="false"
          :min="0"
          :max="1"
          :step="0.01"
          @mousedown.native="beforePictureResize"
        ></el-slider>
      </div>
      <div>
        <span>透明度</span>
        <el-slider
          v-model="tabOpacity"
          class="operation-area"
          :show-input="true"
          :show-tooltip="false"
          :min="0"
          :max="1"
          :step="0.1"
        ></el-slider>
      </div>
      <div>
        <span>翻转</span>
        <div class="operation-area">
          <i
            :class="{
              'el-icon-d-caret': true,
              'icon-ban': flip.h
            }"
            @click="handlePictureFlip('X')"
          ></i>
          <i
            :class="{
              'el-icon-d-caret': true,
              'horizontal-icon': true,
              'icon-ban': flip.v
            }"
            @click="handlePictureFlip('Y')"
          ></i>
        </div>
      </div>
    </div>
      <el-dialog
      :visible.sync="pictureDialog"
      width="80%"
      :before-close="handleClose"
    >
     <template slot="title">
      <div>历史上传-贴图</div>
    </template>
      <div>
        <CommonCardPageList v-if="pictureDialog" :spaceInfo="spaceInfo" :type="2" @select-card="handleSelectCard">
        </CommonCardPageList>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="pictureDialog = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
import materialStore from '@/views/mediaFactory/media/store'
// import Loading from '../Loading'
import { mapState, mapMutations } from 'vuex'
import { commonUploadFile } from '@/views/mediaFactory/utils/upload'
import CommonCardPageList from '@/components/common/CommonCardPageList'
export default {
  components: {
    // Loading,
    CommonCardPageList
  },
  props: {
    pictureRotate: {
      type: Number,
      default: 0
    },
    materialList: {
      type: Array,
      default: function () {}
    },
    spaceInfo: {
      type: Object,
      default: () => {

      }
    },
    backList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pictureDialog: false,
      mouseTarget: null,
      firstCategory: {},
      secondCategory: {},
      firstCategoryList: [],
      secondCategoryList: [],
      pictureList: [],
      pictureFileList: [],
      picShowAmount: 80,
      isListChange: true,
      isEmpty: false,
      isPictureLoading: false,
      isShowLocal: true,
      cardSrc: '',
      cardType: '',
      isCardLoading: false,
      isUploading: false,
      tabRotate: 0,
      tabResize: 1,
      tabOpacity: 1,
      pagination: {
        currentPage: 1,
        pageSize: 20
      },
      flip: {
        v: false,
        h: false
      },
      loadingImage: require('@/assets/onlineClip/material1004.png'),
      isShowCard: false,
      isSelected: 0
    }
  },
  computed: {
    ...mapState({
      selected: state => state.selected,
      selectedTarget: state => state.selectedTarget,
      playingPicture: state => state.playingPicture,
      playingPictureIndex: state => state.playingPictureIndex,
      pictureTrackList: state => state.pictureTrackList,
      activeName: state => state.activeName,
      selectedPictureResource: state => state.selectedPictureResource
    })
  },
  watch: {
    activeName: function (val) {
      if (val !== 'picture') {
        return true
      }
      this.$nextTick(() => {
        // 修复贴图列表未加载完成就打开操作页所导致的列表图片加载中问题
        const target = document.querySelector('.picture-list')
        if (!val && target && target.scrollTop === 0) {
          document.querySelector('.picture-list').scrollTop = 1
        }
      })
    },
    selectedTarget: function (val) {
      if (!val || !this.selected.type || this.activeName !== 'picture') {
        return true
      }
      this.initTab(val)
    },
    'selectedTarget.whirl': function (angle) {
      let realRotate = angle
      if (angle > 360) {
        realRotate = angle - 360
      }
      if (angle < 0) {
        realRotate = angle + 360
      }
      this.tabRotate = realRotate
      this.isFromOnline = true
    },
    tabRotate: function (val) {
      if (this.isFromOnline) {
        this.isFromOnline = false
        return false
      }
      if (!this.selectedTarget || val === this.selectedTarget.whirl) {
        return false
      }
      this.$store.commit('drrTabRotate', val)
    },
    tabResize: function (val) {
      if (!this.selectedTarget || val === this.selectedTarget.scale) {
        return false
      }
      this.$store.commit('drrTabResize', val)
    },
    tabOpacity: function (val) {
      if (!this.selectedTarget || val === this.selectedTarget.transparency) {
        return false
      }
      this.$store.commit('drrTabOpacity', val)
    }

  },
  methods: {
    ...mapMutations({
      handlePictureStart: 'dragStart',
      handlePictureDragging: 'tabDragging',
      handlePictureDragEnd: 'tabDragEnd'
    }),
    beforePictureResize() {
      this.$store.commit('drrTabBeforeResize', this.tabResize)
    },
    handlePictureOver(index, item) {
      if (item.loaded) {
        this.isCardLoading = false
      } else {
        this.isCardLoading = true
      }
      this.mouseTarget = index
      this.cardSrc = item.resourceUrl
      this.cardType = item.resourceType === 2 ? 'picture' : 'video'
      this.isShowCard = true
    },
    handlePictureOut(e) {
      this.isCardLoading = false
      this.mouseTarget = null
      this.isShowCard = false
    },
    handlePictureIconAdd(picture) {
      if (this.backList[0].length === 0) {
        this.$message('背景轨道为空，请添加背景素材后再试')
        return false
      }
      if (this.materialList.length === 0) {
        // this.$message('视频轨道为空，请添加视频素材后再试')
        return false
      }
      this.$emit('icon-add', 'picture', picture)
    },
    handleLocalPictureDelete(index) {
      const isSelectd = []
      this.pictureTrackList.forEach(item => {
        const isSelectdIndex = item.findIndex(e => e.md5 === this.selectedPictureResource[index].md5)
        if (isSelectdIndex > -1) {
          isSelectd.push(isSelectdIndex)
        }
      })
      if (isSelectd.length > 0) {
        this.$message('贴图在轨道上，请先清除后再试')
      } else {
        this.$store.commit('deletPictureResource', { index: index, num: 1 })
      }
      this.isShowCard = false
    },
    uploadFile(paramsFile) {
      const that = this
      that.isUploading = true
      let callback = function (e) {
        e.then(res => {
          that.isUploading = false
          if (res.code === 0) {
            that.handleSetPictureResource(res.data)
          } else {
            that.$message.error(res.message)
          }
        }).catch((error) => {
          that.isUploading = false
          that.$notify({
            title: '操作失败',
            type: 'error',
            message: error.message
          })
        })
      }
      commonUploadFile(paramsFile, 2, this.spaceInfo.spaceId, callback)
    },
    // uploadFile(paramsFile) {
    //   commonUploadFile(paramsFile, 2, this.spaceInfo.spaceId).then(res => {
    //     if (res.code === 0) {
    //       this.handleSetPictureResource(res.data)
    //     } else {
    //       this.$message.error(res.message)
    //     }
    //   })
    // },
    handleNetworkPictureShow() {
      if (this.judgeLoading()) {
        return false
      }
      this.isShowLocal = false
      this.isListChange = false
      this.isListChange = true
    },
    handleLocalPictureShow() {
      if (this.judgeLoading()) {
        return false
      }
      this.isShowLocal = true
      this.isListChange = false
      this.isListChange = true
    },
    handlePictureFlip(way) {
      if ((way === 'X' && this.flip.h) || (way === 'Y' && this.flip.v)) {
        return false
      }
      if (way === 'X') {
        this.flip.v = !this.flip.v
      }
      if (way === 'Y') {
        this.flip.h = !this.flip.h
      }
      this.$store.commit('drrTabFlip', way)
    },
    judgePictureDraggable(picture) {
      if (this.materialList.length === 0) {
        this.$message('视频轨道为空，请添加视频素材后再试')
        return false
      }
      if (!picture.duration) {
        this.$message('素材加载中，右侧预览加载完毕后方可添加')
        return false
      }
      return true
    },
    judgeLoading() {
      if (this.isPictureLoading) {
        return true
      }
      return false
    },
    loadedCardContent(e) {
      this.isCardLoading = false
      let targetList = this.selectedPictureResource
      if (e.target.src === this.cardSrc) {
        const index = targetList.findIndex(item => {
          return item.resourceUrl === this.cardSrc
        })
        if (this.cardType === 'video') {
          targetList[index].duration = targetList[index].duration ? targetList[index].duration : e.target.duration
        } else {
          targetList[index].duration = 10
        }
        targetList[index].loaded = true
      }
    },
    resetData() {
      this.tabRotate = 0
      this.tabResize = 1
      this.tabOpacity = 1
      this.flip = {
        v: false,
        h: false
      }
    },
    fetchData() {
    },
    initTab(val) {
      this.tabRotate = val.whirl
      this.tabResize = val.scale
      this.tabOpacity = val.transparency
      this.flip = {
        v: val.overturn.indexOf('v') !== -1,
        h: val.overturn.indexOf('h') !== -1
      }
    },
    handleClose() {
      this.isSelected = 0
      this.pictureDialog = false
    },
    handleOpenDialog() {
      this.isSelected = 0
      this.pictureDialog = true
    },
    handleSelectCard(data) {
      this.handleSetPictureResource(data)
    },
    handleSetPictureResource(data) {
      if (this.selectedPictureResource.findIndex(item => item.md5 === data.md5) > -1) {
        this.$message('贴图已选择')
      } else {
        this.$store.commit('setPictureResource', data)
        this.isSelected = this.isSelected + 1
      }
    },
    handleCancel() {
      if (this.isSelected) {
        const index = this.selectedPictureResource.length - this.isSelected
        this.$store.commit('deletPictureResource', { index: index, num: this.isSelected })
        this.isSelected = 0
      }
      this.pictureDialog = false
    }
  },
  created() {
    this.tabRotate = this.pictureRotate
    this.isUploading = materialStore.isPicUploading
    this.$nextTick(() => {
      if (this.activeName === 'picture') {
        this.initTab(this.selectedTarget)
      }
    })
  }
}
</script>
<style lang="stylus" scoped>
.picture-tab
  position relative
  height 100%
  &:focus
    outline 0px
.picture-list
  height 70%
  user-select none // 禁止选中 避免在不允许拖拽的情况下 使用浏览器默认选中行为后再进行拖拽
  // max-height 220px
.local-picture-list
  height auto
  display flex
.picture-draggable
  width fit-content
  height 100%
  outline 0px
.picture-style
  display inline-block
  position relative
  margin 5px 0
  width 90px
  height 75px
  border 2px solid #f2f2f2
  border-radius 3px
  background #ececec
  transition all .3s
  &:hover
    border-color #ff8b00
  .el-image
    width 100%
    // height 100%
    border-radius 3px 3px 0 0
.picture-plus-icon,
.picture-delete-icon
  position absolute
  top 1px
  font-size 15px
  font-weight 600
  cursor pointer
  z-index 2
  color #fff
.picture-plus-icon
  right 1px
.picture-delete-icon
  left 3px
.operation-tab
  padding 30px 10px
  span
    display inline-block
    width 10%
    text-align center
    vertical-align super
.operation-area
  display inline-block
  width 85%
  height 50px
  vertical-align middle
  >>>.el-slider__runway
    height 2.5px
    .el-slider__bar
      height 2.5px
    .el-slider__button
      width 10px
      height 10px
.el-icon-d-caret
  margin-right 20px
  vertical-align middle
  font-size 23px
  line-height 35px
  cursor pointer
  &:hover
    color #ff8b00
.horizontal-icon
  transform rotate(90deg)
.icon-ban
  color #ccc
  cursor default
  &:hover
    color #ccc
    cursor default
.picture-card
  position absolute
  top 0px
  right -200px
  width 200px
  height 140px
  background #d7d7d7
  border-color #d7d7d7
  z-index 3
  >>>.el-card__body
    position relative
    top 50%
    height inherit
    text-align center
    transform translateY(-50%)
  .el-image
    width 100%
    height 100%
  video
    width 100%
    height 100%
.mouse-image
  position fixed
  top 0px
  left 0px
  z-index 9999
  pointer-events none
.picture-container
  position relative
  height 100%
  overflow hidden
.category-container
  margin-bottom 10px
.category-style
  display inline-block
  margin 3px
  padding 0px 5px
  max-width 80px
  height 25px
  line-height 25px
  text-align center
  font-size 12px
  color #999
  border 1px solid #fff
  border-radius 5px
  background #fff
  cursor pointer
  transition all .3s
  &:hover
    border 1px solid #ff8b00
    color #ff8b00
.category-active
  border 1px solid #ff8b00
  color #ff8b00
.picture-empty
  height 20vh
  line-height 20vh
  font-size 13px
  text-align center
  color #aaa
.button-style
  position absolute
  bottom 5px
  // 避免遮住滚动条
  width 99%
  background #f2f2f2
.location-upload
  display inline-block
  margin-left 8px
  // margin 10px 3px 3px 3px
.picture-icons
  position absolute
  bottom 0px
  right 0px
  i
    margin-right 10px
    font-size 18px
    cursor pointer
    &:hover
      color #ff8b00
.active-picture-list
  color #ff8b00
// .methods-button
//   width 100px
//   height 30px
//   line-height 10px
//   font-size 13px
//   color #888
//   border 1px solid #777
//   &:focus
//     background #fff
//   &:hover
//     color #ff8b00
//     border-color #ff8b00
//     background #fff
.message
  font-size 12px
  color #ccc
  cursor default
  vertical-align middle
::-webkit-scrollbar
  width 5px
  height 5px
::-webkit-scrollbar-thumb
  border-radius 5px
  background-color #ccc
.picture-style-title
  padding 0px 2px 4px
  width 100%
  font-size 12px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  cursor default
>>>.image__error
  display flex
  justify-content center
  align-items center
  font-size 14px
  color #c0c4cc
  vertical-align middle
  background #f5f7fa
  height 50.63px
</style>
